import { isJSON } from "../../util/isJSON";

/**
 * Hook que toma un string de editoriales y lo devuelve como un array de objetos,
 * cada uno con propiedades "name" y "slug", donde el slug replica la lógica del backend.
 *
 * @param {Object} props - Props del hook.
 * @param {string} props.publisherString - El string de editoriales a parsear.
 * @returns {Object} - Un objeto con la función getPublishers.
 */
export const usePublisherParser = ({ publisherString = "" }) => {
	/**
	 * Función que imita la lógica PHP del backend para generar slugs ASCII.
	 */
	const normalize = (str, replace = [], delimiter = "-") => {
		if (!str) return "";

		if (Array.isArray(replace) && replace.length > 0) {
			replace.forEach((item) => {
				str = str.split(item).join(" ");
			});
		}

		str = str
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "") // elimina tildes
			.replace(/[^a-zA-Z0-9\/_|+ -]/g, "") // elimina símbolos no permitidos
			.toLowerCase()
			.trim()
			.replace(/^[-]+|[-]+$/g, "") // elimina guiones extremos
			.replace(/[\/_|+ -]+/g, delimiter); // normaliza separadores

		return str;
	};

	const getPublishers = () => {
		if (typeof publisherString !== "string" || !publisherString.length) return [];

		if (isJSON(publisherString)) {
			try {
				const parsed = JSON.parse(publisherString);
				if (Array.isArray(parsed)) {
					return parsed.map((name) => ({
						name,
						slug: normalize(name),
					}));
				}
			} catch {
				// fallback por si falla el JSON.parse a pesar de isJSON
				return [];
			}
		}

		// Fallback por si es texto plano con nombres separados por comas
		return publisherString.split(",").map((name) => {
			const trimmed = name.trim();
			return {
				name: trimmed,
				slug: normalize(trimmed),
			};
		});
	};

	return { getPublishers };
};
